// extracted by mini-css-extract-plugin
module.exports = {"email":"member-operations__Email__email"};